import config from '@/config'

export function buildTicketLink(ticketId) {
  return config.urlTemplates.ticket.template({
    id: ticketId,
  })
}

export function buildOrderLink(orderId) {
  return config.urlTemplates.requestOrder.template({
    id: orderId,
  })
}

export function buildRegaladeTicketLink(ticketId) {
  return config.urlTemplates.regaladeTicket.template({
    id: ticketId,
  })
}

export function buildRegaladeRequestLink(requestId) {
  return config.urlTemplates.regaladeRequest.template({
    id: requestId,
  })
}

export function buildDocumentationLink(filename) {
  return config.urlTemplates.requestDocumentation.template({
    filename: encodeURIComponent(filename),
  })
}

export function buildLegacyDownloadLink(sslId) {
  return config.urlTemplates.legacyDownload.template({
    id: sslId,
  })
}
